import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full" data-id="element-331">
    <div className="flex items-center mb-4" data-id="element-332">
      <div className="w-12 h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-gold font-serif font-bold text-xl border border-brand-gold/20 mr-4 shrink-0" data-id="element-333">
        {initials}
      </div>
      <div data-id="element-334">
        <div className="flex text-brand-gold mb-1 text-[15px]" data-id="element-335">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-336" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-337">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-338">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px]" data-id="element-339">"{text}"</p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials = [{
    initials: 'VG',
    name: 'Valentina G.',
    location: 'Buenos Aires',
    text: 'Llegué sin saber por dónde empezar. El Tomo I me dio la primera claridad real que tuve en años. Literalmente en una tarde.'
  }, {
    initials: 'CR',
    name: 'Carolina R.',
    location: 'Córdoba',
    text: 'El Tomo II me cambió la relación con mi familia. Ya no cargo con lo que no es mío y eso se nota en mi cuerpo.'
  }, {
    initials: 'MF',
    name: 'Marcela F.',
    location: 'Rosario',
    text: 'El Protocolo de la Sombra del Tomo V es lo más honesto y poderoso que hice en mi proceso. Vale cada peso.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-340">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-341">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-342" />)}
      </div>
    </Section>;
};
export const ExtendedTestimonials = () => {
  const testimonials = [{
    initials: 'VG',
    name: 'Valentina G.',
    location: 'Buenos Aires',
    product: 'Método Completo',
    text: 'Llegué después de tres años de terapia sin poder soltar a mi ex. En dos semanas de aplicar el Tomo II entendí lo que tres años de sesiones no me habían dado. El alivio fue físico, literal.'
  }, {
    initials: 'CR',
    name: 'Carolina R.',
    location: 'Córdoba',
    product: 'Método + Bitácora',
    text: 'El Tomo IV me cambió las noches. Tenía insomnio desde hacía meses. La secuencia nocturna me parece increíble. Ahora duermo de corrido y me levanto sin ese peso en el pecho.'
  }, {
    initials: 'MF',
    name: 'Marcela F.',
    location: 'Rosario',
    product: 'Método Completo',
    text: 'Lo del Tomo V fue lo más difícil y lo más liberador. Nunca había podido mirar mis partes feas con tanto amor. El protocolo de la sombra es un regalo.'
  }, {
    initials: 'SP',
    name: 'Sofía P.',
    location: 'Mendoza',
    product: 'Método + Bitácora',
    text: 'La Bitácora de 21 días fue lo que necesitaba para no dejar los tomos juntar polvo digital. Cada día sabía exactamente qué hacer. En la semana 2 empecé a notar cambios reales.'
  }];
  return <Section className="bg-brand-surface/30 rounded-3xl my-16" data-id="element-343">
      <div className="text-center mb-12" data-id="element-344">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-345">
          ❤️ MÁS PERSONAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-346">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-347" />)}
      </div>
    </Section>;
};